import React from 'react';
import { Link } from 'react-router-dom';
import { Megaphone, ArrowRight, Clock } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';

const AnnouncementsPanel = ({ announcements = [], maxItems = 5 }) => {
  const { userTheme } = useTheme();
  const items = announcements.slice(0, maxItems);

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    const now = new Date();
    const diffMs = now - d;
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    if (diffHours < 1) return 'Just now';
    if (diffHours < 24) return `${diffHours}h ago`;
    if (diffDays < 7) return `${diffDays}d ago`;
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  };

  return (
    <div className="rounded-xl border border-gray-200 bg-white overflow-hidden h-full flex flex-col">
      {/* Header */}
      <div className="flex items-center justify-between px-5 py-3 border-b border-gray-100" style={{ backgroundColor: userTheme?.dashboardWidgetHeader?.backgroundColor }}>
        <div className="flex items-center gap-2">
          <Megaphone className="w-4 h-4 text-orange-500" />
          <h3 className="text-sm font-semibold text-gray-800">Announcements</h3>
        </div>
        <Link
          to="/admin/announcements"
          className="text-xs text-blue-600 hover:text-blue-700 font-medium flex items-center gap-1"
        >
          View all <ArrowRight className="w-3 h-3" />
        </Link>
      </div>

      {/* List */}
      <div className="flex-1 divide-y divide-gray-50">
        {items.length === 0 ? (
          <div className="p-5 text-center">
            <p className="text-sm text-gray-500">No announcements yet.</p>
          </div>
        ) : (
          items.map((item, idx) => (
            <Link
              key={item._id || item.id || idx}
              to="/admin/announcements"
              className="block px-5 py-3 hover:bg-gray-50 transition"
            >
              <div className="flex items-start justify-between gap-3">
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-gray-800 truncate">
                    {item.title}
                  </p>
                  {item.excerpt && (
                    <p className="text-xs text-gray-500 truncate mt-0.5">
                      {item.excerpt}
                    </p>
                  )}
                </div>
                <div className="flex items-center gap-1 text-xs text-gray-400 flex-shrink-0">
                  <Clock className="w-3 h-3" />
                  {formatDate(item.created_at || item.published_at)}
                </div>
              </div>
            </Link>
          ))
        )}
      </div>
    </div>
  );
};

export default AnnouncementsPanel;
